import React from 'react';
import PropTypes from 'prop-types';
import './Main.scss';

const Index = ({ children }) => {
	return (
		<main id="main" className="layout__main" aria-label="Main content">
			<div className="main-container">{children}</div>
		</main>
	);
};

Index.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Index;
